import { Fragment } from 'react'
import { useTranslation } from '@mc/i18n'
import Link from 'components/Link'

interface StatisticsCardProps {
  value: string
  label: string
  disclaimer: string
  sources: string[]
}

const StatisticsCard = ({
  value,
  label,
  disclaimer,
  sources,
}: StatisticsCardProps) => {
  const { t } = useTranslation('@mc/next')

  return (
    <div className='d-flex flex-column flex-1 col-12 col-lg-6'>
      <div
        className='d-flex flex-column align-items-center mc-p-4 mc-corners--lg justify-content-center mc-text--center mc-p-8 mc-h-100 '
        style={{
          backgroundColor:
            'rgba(var(--mc-color-bg-container-tint-dark-rgb), 0.75)',
        }}
      >
        <div className='mc-text-d2 mc-text-color--yellow-100'>{value}</div>
        <div className='mc-text-h3 mc-my-3'>{label}</div>
        <div
          style={{ maxWidth: '300px' }}
          className='mc-text-color--tint mc-text-small'
        >
          {disclaimer}
        </div>
      </div>
      <div
        className='d-flex mc-mt-2 mc-gap-2 justify-content-end'
        style={{
          height: 'var(--mc-scale-8)',
        }}
      >
        {sources.map((source, index) => (
          <Fragment key={index}>
            <Link
              className='mc-text--link mc-text-color--tint mc-text-small'
              href={source}
              passHref
              onClick={(e) => e.stopPropagation()}
              newTab={true}
            >
              {t('forBusiness.statsSection.source', { index: index + 1 })}
            </Link>
            {index < sources.length - 1 && (
              <span className='mc-text-color--tint mc-text-small'>{'|'}</span>
            )}
          </Fragment>
        ))}
      </div>
    </div>
  )
}

export const StatisticsCards = () => {
  const { t } = useTranslation('@mc/next')

  const statistics = [
    {
      value: t('forBusiness.statsSection.salesStat'),
      label: t('forBusiness.statsSection.salesTitle'),
      disclaimer: t('forBusiness.statsSection.salesDisclaimer'),
    },
    {
      value: t('forBusiness.statsSection.retentionStat'),
      label: t('forBusiness.statsSection.retentionTitle'),
      disclaimer: t('forBusiness.statsSection.retentionDisclaimer'),
    },
  ]

  const statisticsSources = [
    'https://elearningindustry.com/learning-roi-how-to-measure-the-business-impact-of-learning-programs',
    'https://www.harvardbusiness.org/frontline-leaders-are-hungry-for-development-can-organizations-deliver/',
  ]
  return (
    <div className='d-flex flex-column flex-md-row mc-mb-14 mc-mx-0 mc-mx-md-6 mc-gap-4'>
      {statistics.map((statistic, i) => (
        <StatisticsCard
          key={statistic.value}
          value={statistic.value}
          label={statistic.label}
          disclaimer={statistic.disclaimer}
          sources={i === statistics.length - 1 ? statisticsSources : []}
        />
      ))}
    </div>
  )
}
